import { combineReducers } from 'redux';
import { authenReducer } from './authen/reducer';
import { alertReducer } from './alert/reducer';
import { authenLineReducer } from './line/reducer';
import { infoReducer } from './info/reducer';
import { titleReducer } from './title/reducer';
import { warrantyReducer } from './warranty/reducer';

const rootReducer = combineReducers({
  authen: authenReducer,
  alert: alertReducer,
  line: authenLineReducer,
  info: infoReducer,
  title: titleReducer,
  warranty: warrantyReducer,
});

export default rootReducer;
